// store.js
import { createStore } from 'redux';
import tabReducer from './reducer';

const store = createStore(tabReducer);

export default store;
